<template>
  <v-dialog
    v-model="dialog"
    max-width="700px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" fab depressed small>
        <v-icon>mdi-pencil-outline</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-form ref="formLimits" v-model="valid" lazy-validation>
        <v-toolbar flat>
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("editLimits") }} </v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" :md="$isCreditOnline() ? 6 : 12">
              <!-- ========================================= -->
              <!--              BETS LIMITS             -->
              <!-- ========================================= -->
              <v-subheader class="overline pt-4"
                >{{ $t("bettingLimits") }}
              </v-subheader>
              <!-- Limites Bets -->
              <div class="pa-2 px-6">
                <v-checkbox v-model="noLimitsBet" :label="$t('noLimitBet')">
                </v-checkbox>
                <v-text-field
                  v-model="contact.aposta_maxima"
                  :label="$t('betMaximum')"
                  :placeholder="$t('betMaximum')"
                  :prefix="$t('labelCurrency')"
                  outlined
                  required
                  class="grey--text mb-2"
                  type="Number"
                  :disabled="noLimitsBet"
                ></v-text-field>
              </div>
              <v-subheader class="overline pt-4 pb-8"
                >{{ $t("useTimeLimits") }}
              </v-subheader>

              <!-- Limites Atividade -->
              <div class="p2-4 px-6">
                <v-checkbox
                  v-model="noLimitsActive"
                  :label="$t('noActivityLimit')"
                >
                </v-checkbox>
                <v-select
                  v-model="contact.minutos_atividade"
                  :label="$t('useTimeLimits')"
                  :placeholder="$t('useTimeLimits')"
                  :items="minutesActivity"
                  item-text="name"
                  item-value="id"
                  outlined
                  required
                  class="grey--text mb-2"
                  :disabled="noLimitsActive"
                ></v-select>
              </div>
            </v-col>
            <v-col cols="12" md="6" v-if="$isCreditOnline()">
              <!-- ========================================= -->
              <!--               DEPOSIT LIMITS              -->
              <!-- ========================================= -->
              <v-subheader class="overline pt-2"
                >{{ $t("depositLimitValues") }}
              </v-subheader>
              <!-- Limites Depositos -->
              <div class="pa-2 px-6">
                <v-checkbox
                  v-model="noLimitsDeposit"
                  :label="$t('noDepositLimit')"
                >
                </v-checkbox>
                <v-text-field
                  v-model="contact.deposito_maximo"
                  placeholder="00,00"
                  :label="$t('maximumDeposit')"
                  :prefix="$t('labelCurrency')"
                  outlined
                  required
                  type="Number"
                  :disabled="noLimitsDeposit"
                ></v-text-field>
              </div>
              <!-- ========================================= -->
              <!--               DEPOSIT TIME LIMITS         -->
              <!-- ========================================= -->
              <v-subheader class="overline"
                >{{ $t("depositTimeLimit") }}
              </v-subheader>
              <!-- Limites Depositos -->
              <div class="pa-1 px-6">
                <v-checkbox
                  v-model="noLimitsTime"
                  :label="$t('noDepositTimeLimit')"
                >
                </v-checkbox>
                <v-select
                  v-model="contact.deposito_intervalo"
                  :items="items"
                  :label="$t('depositInterval')"
                  item-text="name"
                  item-value="id"
                  outlined
                  required
                  :disabled="noLimitsTime"
                ></v-select>
                <v-text-field
                  v-model="contact.deposito_limite_valor"
                  placeholder="00,00"
                  :label="$t('depositLimitValue')"
                  :prefix="$t('labelCurrency')"
                  outlined
                  required
                  type="Number"
                  :disabled="noLimitsTime || contact.deposito_intervalo == '0'"
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pa-5">
          <div class="flex-grow-1"></div>
          <v-btn text outlined="" @click="dialog = false">
            {{ $t("BtnCancel") }}
          </v-btn>
          <v-btn
            depressed
            color="primary"
            type="submit"
            @click.prevent="editUser"
            :loading="loading"
            :disabled="loading"
          >
            {{ $t("BtnSave") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import qs from "qs"; // convert obj in "x-www-form-urlencoded format".
import { validate } from "@/util/form-validate.js";

export default {
  name: "dialogEditContact",
  props: ["userLimits"],
  data: () => ({
    dialog: false,
    loading: false,
    valid: true,
    disableBtn: true,

    // Rules Default Import
    rules: {
      required: validate.required,
    },
    contact: {
      aposta_maxima: "",
      deposito_maximo: "",
      deposito_intervalo: "",
      deposito_limite_valor: "",
      minutos_atividade: "",
    },
    noLimitsBet: false,
    noLimitsDeposit: false,
    noLimitsTime: false,
    noLimitsActive: false,
    items: [],
    minutesActivity: [],
  }),

  mounted() {
    this.getDataUser();
    this.items = [
      { id: "24", name: this.$t("twentyFourHours") },
      { id: "48", name: this.$t("fortyEightHours") },
      { id: "168", name: this.$t("sevenDays") },
      { id: "720", name: this.$t("thirtyDays") },
      { id: "0", name: this.$t("noLimits") },
    ];
    this.minutesActivity = [
      { id: "30", name: this.$t("twentyMinutes") },
      { id: "60", name: this.$t("sixtyMinutes") },
      { id: "90", name: this.$t("ninetyMinutes") },
      { id: "120", name: this.$t("oneHundredTwentyMinutes") },
      { id: "0", name: this.$t("noLimits") },
    ];
  },

  watch: {
    dialog(val) {
      !val && this.$emit("refresh-user");
      this.getDataUser();
    },
    noLimitsBet(val) {
      if (!val) return;
      this.contact.aposta_maxima = null;
    },
    noLimitsDeposit(val) {
      if (!val) return;
      this.contact.deposito_maximo = null;
    },
    noLimitsTime(val) {
      if (!val) return;
      this.contact.deposito_intervalo = "0";
      this.contact.deposito_limite_valor = null;
    },
    noLimitsActive(val) {
      if (!val) return;
      this.contact.minutos_atividade = null;
    },
    "contact.deposito_intervalo"(val) {
      if (val == "0") {
        this.noLimitsTime = true;
      }
    },
  },

  methods: {
    // Edit User - Dados Contato
    editUser() {
      this.loading = true;
      const params = "player/profile/editPlayer";

      for (const key in this.contact) {
        if (this.contact[key] == null) {
          this.contact[key] = 0;
        }
      }

      const data = {
        etapa: "Limites",
        aposta_maxima: this.contact.aposta_maxima,
        deposito_maximo: this.contact.deposito_maximo,
        deposito_intervalo: this.contact.deposito_intervalo,
        deposito_limite_valor: this.contact.deposito_limite_valor,
        minutos_atividade: this.contact.minutos_atividade,
      };
      this.$axios
        .put(params, qs.stringify(data), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((response) => {
          if (
            this.userInfo.minutos_atividade != this.contact.minutos_atividade
          ) {
            this.$store.commit(
              "setUserTimeLimit",
              this.contact.minutos_atividade
            );
            this.$store.commit("showDialogTimeActivity", false);
          }
          const msg = response.data.messages;
          const color = "success";
          this.$store.commit("setNotification", { msg, color });
          this.dialog = false;
        })
        .catch((error) => {
          const msg = error.response.data.messages.error;
          const color = "red";
          this.$store.commit("setNotification", { msg, color });
        })
        .finally(() => (this.loading = false));
    },

    getDataUser() {
      this.userInfo = this.userLimits;

      this.contact = {
        aposta_maxima: this.userInfo.aposta_maxima,
        deposito_maximo: this.userInfo.deposito_maximo,
        deposito_intervalo: this.userInfo.deposito_intervalo,
        deposito_limite_valor: this.userInfo.deposito_limite_valor,
        minutos_atividade: this.userInfo.minutos_atividade,
      };
      if (
        this.contact.aposta_maxima == null ||
        this.contact.aposta_maxima == "0.00"
      ) {
        this.noLimitsBet = true;
      } else {
        this.noLimitsBet = false;
      }
      if (
        this.contact.deposito_maximo == null ||
        this.contact.deposito_maximo == "0.00"
      ) {
        this.noLimitsDeposit = true;
      } else {
        this.noLimitsDeposit = false;
      }
      if (
        this.contact.deposito_intervalo == null ||
        (this.contact.deposito_intervalo == "0.00" &&
          this.contact.deposito_limite_valor == null) ||
        this.contact.deposito_limite_valor == "0.00"
      ) {
        this.noLimitsTime = true;
      } else {
        this.noLimitsTime = false;
      }
      if (
        this.contact.minutos_atividade == null ||
        this.contact.minutos_atividade == "0"
      ) {
        this.noLimitsActive = true;
      } else {
        this.noLimitsActive = false;
      }
    },
  },
};
</script>
